module.exports = __webpack_public_path__ + "static/media/ryeen.c2030d5b.mp3";